import { SVGProps } from 'react';

const Cable = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17 19a1 1 0 0 1-1-1v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a1 1 0 0 1-1 1m-4 0h4m-4 0v2m4-2v2m-2-7V6.5a3.5 3.5 0 1 0-7 0v11a3.5 3.5 0 1 1-7 0V10M3 5V3m4 2H3a1 1 0 0 0-1 1v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V6a1 1 0 0 0-1-1m0 0V3"
    />
  </svg>
);
export default Cable;
